var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupe484(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 165.383,
    height: 52,
    viewBox: "0 0 165.383 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3f4351;font-size:28px;font-family:Cairo-SemiBold, Cairo;font-weight:600;}.b{fill:url(#a);}.c{fill:url(#b);}.d{fill:url(#c);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -0.935,
    y1: -0.023,
    x2: 0.844,
    y2: 0.786,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#803be2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50b0ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -0.059,
    y1: 0.113,
    x2: 1.72,
    y2: 0.921,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -3.293,
    y1: -1.534,
    x2: 2.907,
    y2: 1.79,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.383)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "a",
    transform: "translate(0 36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NowEdge")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5.543)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M321.281,597.1a5.072,5.072,0,0,0,0-9.829,4.94,4.94,0,0,0-1.249-.157,4.279,4.279,0,0,0-.473.024A4.023,4.023,0,0,0,321.9,583.5a4,4,0,0,0-4-4,4.184,4.184,0,0,0-.63.048,4.086,4.086,0,0,0-.855.233,3.558,3.558,0,0,0,.414-.744,3.732,3.732,0,0,0-5.05-4.786c.01-.118.017-.236.017-.358a3.734,3.734,0,0,0-7.467,0V583h6.883v-3.13a1.646,1.646,0,1,1,1.64,0V583h-.01v1.637h-8.513v3.726h10.879v.046a1.646,1.646,0,1,1,0,1.548V590H304.336v3.776h13.149v1.64h-.006v3.993a1.646,1.646,0,1,1-1.64,0V595.42H309.7v9.367a1.676,1.676,0,1,1-1.64,0V595.42h-3.727v15.373a3.671,3.671,0,0,0,.1.859,3.733,3.733,0,0,0,7.366-.859,3.563,3.563,0,0,0-.066-.7,3.737,3.737,0,0,0,5.1-4.765,3.628,3.628,0,0,0-.344-.647,4.033,4.033,0,0,0,.737.195,3.917,3.917,0,0,0,.678.059,3.991,3.991,0,0,0,3.012-6.615,3.925,3.925,0,0,0-1.589-1.113,5.137,5.137,0,0,0,.7.049A4.929,4.929,0,0,0,321.281,597.1Zm-.861-5.159a.324.324,0,0,1,.324-.324h.806a.324.324,0,0,1,.324.324v.806a.324.324,0,0,1-.324.324h-.806a.324.324,0,0,1-.324-.324Zm-4.68-7.723a.323.323,0,0,1-.324.323h-.806a.323.323,0,0,1-.324-.323v-.806a.324.324,0,0,1,.324-.324h.806a.324.324,0,0,1,.324.324Z",
    transform: "translate(-280.301 -570.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M249.406,570.167a3.736,3.736,0,0,0-3.735,3.735c0,.122.007.24.017.358a3.735,3.735,0,0,0-5.05,4.786,3.526,3.526,0,0,0,.414.744,4.084,4.084,0,0,0-.856-.233,4.186,4.186,0,0,0-.63-.048,3.99,3.99,0,0,0-3.029,6.594,3.949,3.949,0,0,0,1.377,1.04,4.275,4.275,0,0,0-.473-.024,4.936,4.936,0,0,0-1.249.157,5.071,5.071,0,0,0,0,9.829,4.925,4.925,0,0,0,1.249.157,5.138,5.138,0,0,0,.7-.049,3.922,3.922,0,0,0-1.589,1.113,3.991,3.991,0,0,0,3.012,6.615,3.917,3.917,0,0,0,.678-.059,4.031,4.031,0,0,0,.737-.195,3.6,3.6,0,0,0-.344.647,3.735,3.735,0,0,0,5.1,4.765,3.554,3.554,0,0,0-.066.7,3.733,3.733,0,0,0,7.366.859,3.668,3.668,0,0,0,.1-.859v-2.947h-7.6v-4.11a1.632,1.632,0,0,1,0-2.839v-7.126h1.64v.009h5.956V590H242.6v4.822a1.619,1.619,0,0,1,.344.256,1.646,1.646,0,1,1-2.328,0,1.619,1.619,0,0,1,.344-.256v-6.461h12.179v-3.726h-10.76a1.646,1.646,0,1,1,0-1.64h4.692v-3.13a1.646,1.646,0,1,1,1.64,0V583h4.429v-9.1a3.736,3.736,0,0,0-3.732-3.735ZM236.412,592.7a.324.324,0,0,1-.324.324h-.806a.324.324,0,0,1-.324-.324V591.9a.324.324,0,0,1,.324-.324h.806a.324.324,0,0,1,.324.324Zm3.093,8.485a.324.324,0,0,1,.324-.324h.806a.324.324,0,0,1,.324.324v.806a.324.324,0,0,1-.324.324h-.806a.324.324,0,0,1-.324-.324Z",
    transform: "translate(-232.374 -570.167)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M276.707,651.252a1.633,1.633,0,0,1,0,2.839v2.47h5.956V645.774h-5.956Z",
    transform: "translate(-261.9 -620.521)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupe484);
export default __webpack_public_path__ + "static/media/groupe484.1db4c00a2ff21615d82c304ee19e64e9.svg";
export { ForwardRef as ReactComponent };